$(document).ready(function(){
    $('.ratingLink').click(function(){
        $('a[href="#rating"]').tab('show');
        $("html, body").animate({ scrollTop: $('#tab-list').offset().top }, 1000);
    })
    $('.ArticleAttrSelect').change(function(){
        var select=this;
        $(aAttribute_Image_Values_$ID).each(function(){
            if($("option:selected", select).val()==this[3]){
                                                    
                var newsrc=this[0];
                $('#single-swiper .slider-img').each(function(){
                    var psrc = $(this).attr('data-src');
                    if(typeof psrc  === "undefined"){
                        psrc = $(this).attr('src');
                    }
                    if(typeof psrc  !== "undefined"){
                                                       
                        if(psrc==newsrc){
                            $(galleryTop).swipeTo($(this).attr('data-index')-1);
                        }
                    }
                });
            }
        })
    });
    var isMobile = window.matchMedia("only screen and (max-width: 769px)");
    var galleryTop = new Swiper('#single-swiper', {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        centeredSlides: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        onSlideChangeEnd: function(swiper){
            $('#single-thumbs .swiper-slide').each(function(){
                $(this).removeClass('active');
            })
            $('#single-thumbs .swiper-slide').eq(galleryTop.realIndex).addClass('active');
        }
    });
    if (isMobile.matches) {
        var galleryThumbs = new Swiper('#single-thumbs', {
            spaceBetween: 10,
            slidesPerView: 5,
            direction:'horizontal'
        });
    } else {
        var galleryThumbs = new Swiper('#single-thumbs', {
            direction: 'vertical',
            slidesPerView: 5,
            nextButton: '.icon-arrow-down',
            prevButton: '.icon-arrow-up',
            spaceBetween: 0,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15
        });
    }

    $('#single-thumbs .swiper-slide').click(function(){
        var slide = $(this);
        $('#single-thumbs .swiper-slide').each(function(){
            $(this).removeClass('active');
        })
        slide.addClass('active');
        galleryTop.slideTo(slide.index());
    })
    if(galleryThumbs.slides.length <= 4) {
        $('#single-thumbs .icon-arrow-down,#single-thumbs .icon-arrow-up').hide();
    }
})